/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HostNameAndTldAndApiCurrencyCodeApiKeyData } from './HostNameAndTldAndApiCurrencyCodeApiKeyData';
import {
    HostNameAndTldAndApiCurrencyCodeApiKeyDataFromJSON,
    HostNameAndTldAndApiCurrencyCodeApiKeyDataFromJSONTyped,
    HostNameAndTldAndApiCurrencyCodeApiKeyDataToJSON,
    HostNameAndTldAndApiCurrencyCodeApiKeyDataToJSONTyped,
} from './HostNameAndTldAndApiCurrencyCodeApiKeyData';

/**
 * 
 * @export
 * @interface GlamiIntegrationInput
 */
export interface GlamiIntegrationInput {
    /**
     * 
     * @type {Array<HostNameAndTldAndApiCurrencyCodeApiKeyData>}
     * @memberof GlamiIntegrationInput
     */
    hostNameAndTldAndApiCurrencyCodeApiKeyData?: Array<HostNameAndTldAndApiCurrencyCodeApiKeyData>;
}

/**
 * Check if a given object implements the GlamiIntegrationInput interface.
 */
export function instanceOfGlamiIntegrationInput(value: object): value is GlamiIntegrationInput {
    return true;
}

export function GlamiIntegrationInputFromJSON(json: any): GlamiIntegrationInput {
    return GlamiIntegrationInputFromJSONTyped(json, false);
}

export function GlamiIntegrationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlamiIntegrationInput {
    if (json == null) {
        return json;
    }
    return {
        
        'hostNameAndTldAndApiCurrencyCodeApiKeyData': json['hostNameAndTldAndApiCurrencyCodeApiKeyData'] == null ? undefined : ((json['hostNameAndTldAndApiCurrencyCodeApiKeyData'] as Array<any>).map(HostNameAndTldAndApiCurrencyCodeApiKeyDataFromJSON)),
    };
}

export function GlamiIntegrationInputToJSON(json: any): GlamiIntegrationInput {
    return GlamiIntegrationInputToJSONTyped(json, false);
}

export function GlamiIntegrationInputToJSONTyped(value?: GlamiIntegrationInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostNameAndTldAndApiCurrencyCodeApiKeyData': value['hostNameAndTldAndApiCurrencyCodeApiKeyData'] == null ? undefined : ((value['hostNameAndTldAndApiCurrencyCodeApiKeyData'] as Array<any>).map(HostNameAndTldAndApiCurrencyCodeApiKeyDataToJSON)),
    };
}

